export const mediaUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export function QStimulus({ q, className = "" }) {
  if (q?.question_svg) {
    return (
      <div
        data-testid="q-stimulus-svg"
        className={`q-svg my-4 flex justify-center [&>svg]:max-w-full [&>svg]:h-auto [&>svg]:max-h-48 ${className}`}
        dangerouslySetInnerHTML={{ __html: q.question_svg }}
      />
    );
  }
  if (q?.question_image) {
    return (
      <div className={`my-4 flex justify-center ${className}`}>
        <img data-testid="q-stimulus-img" src={mediaUrl(q.question_image)} alt="stimulus soal" className="max-h-56 max-w-full rounded-xl border-2 border-su-border object-contain bg-white" />
      </div>
    );
  }
  return null;
}

export function OptMedia({ opt }) {
  if (opt?.svg) {
    return <div className="q-svg w-20 h-20 shrink-0 flex items-center justify-center [&>svg]:max-w-full [&>svg]:max-h-full" dangerouslySetInnerHTML={{ __html: opt.svg }} />;
  }
  if (opt?.image) {
    return <img src={mediaUrl(opt.image)} alt={`opsi ${opt.key}`} className="w-20 h-20 shrink-0 object-contain rounded-lg border border-su-border bg-white" />;
  }
  return null;
}

export function hasMedia(opt) {
  return !!(opt?.svg || opt?.image);
}
